import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "../../utils/utils";
import { showToastType } from "../../utils/constants/appConstants";

export default function useLoginSuccessToast() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.successMessage) {
      showToast(location.state.successMessage, showToastType.success);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);
}
